export class ApiRoutingUrl {
  public static authUrl = "/accounts/login";
  public static AuthenticationUsingSDPIdentityUrl = "/accounts/cms-login";
  public static authTest = "/tests/test-auth/";
  public static forgotCredentials = "/users/forgot-password";
  public static userAgreementUrl = "/usersGDPRConsent/";
  public static userAgreementContent = "/usersGDPRConsent/content/";
  public static clientSettingsUrl = "/settings/clientSettings";
  public static bookFileDownloadUrl = "/books/file";
  public static bookshelfsearch = "/books/bookshelf-search";
  public static bookshelfSearchStatusesFilters = "/books/bookshelf-search-statuses-filters";
  public static bookshelfitemsUrl = "/users/bookshelf-items/";
  public static questionAnswers = "/settings/questionsAnswers"; 
  public static userAnnotations = "/annotations/";
  public static booksContentDownloadUrl = "/books/onlineFileProviders/";
  public static bookContentWithEncodedParm = "/books/onlineFileProvidersEncoded?encodedFilePath=";
  public static bookComplicatedResourcesProviderUrl = "/wildcards/complicatedResources/";
  public static onlineResources = "/books/online-resource";
  public static dictionariesContentDownloadUrl = "/dictionaries/onlineFileProviders/";
  public static externalTokenUrl = "/tests/get-external-token/";
  public static getStudentArchivedLevels = "/student-booklist-history/student-levels/";
  public static getStudentBookshelfItemsHistory = "/student-booklist-history/student-bookshelf-items-history/";
  public static getUserGuide = "/books/released-user-guide"; 
  public static logout = "/accounts/logout";
  public static usersGDPRConsentContent = "/usersGDPRConsent/content";
}
